const setupSwipeDetection = ({
  container,
  callback
}) => {
  const threshold = 20;
  const allowedTime = 100;
  let startX = 0;
  let dist = 0;
  let elapsedTime = 0;
  let startTime = 0;
  container.addEventListener(
    "touchstart",
    (event) => {
      const touchObject = event.changedTouches[0];
      dist = 0;
      startX = touchObject.pageX;
      startTime = (/* @__PURE__ */ new Date()).getTime();
    },
    { passive: false }
  );
  container.addEventListener(
    "touchend",
    (event) => {
      const touchObject = event.changedTouches[0];
      dist = touchObject.pageX - startX;
      elapsedTime = (/* @__PURE__ */ new Date()).getTime() - startTime;
      if (elapsedTime > allowedTime && Math.abs(dist) >= threshold) {
        callback(dist > 0);
      }
    },
    { passive: false }
  );
};
export {
  setupSwipeDetection
};
//# sourceMappingURL=setupSwipeDetection.js.map
